import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GetQuery } from './Shared';

interface CustomerList {
    id: number;
    name: string;
    accountType: string;
    phone: string;
    status: string;
}

const CustomerSearchData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [name, setName] = React.useState("");
    const [showInactive, setShowInactive] = React.useState(false);
    const [showResults, setShowResults] = React.useState(false);
    const [readOnly, setReadOnly] = React.useState(false);
    const [canAdd, setCanAdd] = React.useState(false);
    const [canSearch, setCanSearch] = React.useState(false);
    const [result, setResult] = React.useState<CustomerList[]>([]);


    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const apiUrl = "CheckCustomerUserPermission";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            if (result.data.canEdit || result.data.canView || result.data.canCreateQuoteOnlyCustomer) {
                var readOnlyPermission = !result.data.canEdit && result.data.canView;
                var canAddPermission = result.data.canEdit || result.data.canCreateQuoteOnlyCustomer;
                var canSearchPermission = result.data.canEdit || result.data.canView;
                setReadOnly(readOnlyPermission);
                setCanAdd(canAddPermission);
                setCanSearch(canSearchPermission);
                setLoading(false);
            } else {
                //redirect to 403 permission denied
                navigate("/accessdenied");
            }
        }
    }

    const addNew = () => {
        navigate("/customeradd");
    }

    const reset = () => {
        setName("");
        setShowInactive(false);
        setResult([]);
        setShowResults(false);
    }
    
    const search = (e: any) => {
        e.preventDefault();
        
        //check to make sure at least one search field has been entered
        if (name) {
            searchCustomers();
        } else {
            setShowResults(false);
            toast.error("Please enter a customer name");
        }

    }

    const searchCustomers = async () => {
        const apiUrl = 'SearchCustomer?Name=' + name + '&ShowInactive=' + showInactive;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setResult(result.data);
            setShowResults(true);
        }
    }

    const renderDetails = (
        <div>
            <div>
                <label className="input-group--inline" htmlFor="name">
                    <span className="label label--setsizesm">Name</span>
                    <input className="input" type="text" id="name" name="name" value={name} onChange={(e) => setName(e.target.value)}></input>
                </label>
                <label className="input-group--inline" htmlFor="inactive">
                    <span className="label label--setsizesm">Show Inactive</span>
                    <input className="input" type="checkbox" id="inactive" name="showInactive" checked={showInactive} onChange={(e) => setShowInactive(e.target.checked)}></input>
                </label>
                <button className="defaultbutton" type='button' onClick={search} disabled={!canSearch}>Search</button>
                <button className="defaultbutton marginLeft10" type='button' onClick={reset}>Reset</button>
            </div>
            <div>
                <hr></hr>
            </div>
            <div className={showResults ? 'overflowAuto' : 'hidden'}>
                <table className='table tableColours'>
                    <thead>
                        <tr>
                            <th className="hidden">Id</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Phone</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {result.map(customer =>
                            <tr key={customer.id}>
                                <td className="hidden">{customer.id}</td>
                                <td>
                                    <Link to={'/customer/' + customer.id}>
                                        {customer.name}
                                    </Link>
                                </td>
                                <td>{customer.accountType}</td>
                                <td>{customer.phone}</td>
                                <td>{customer.status}</td>
                                <td>
                                    <Link to={'/customer/' + customer.id}>
                                        Open
                                    </Link>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <div className="makeitflexspacebetween">
                <h1>Customer Search</h1>
                <button className={!canAdd ? "hidden" : "defaultbutton defaultbutton__small marginTop10"} type='button' onClick={addNew}>Add New</button>
            </div>
            {contents}
        </div>
    )

}

export default CustomerSearchData;
